import {useEffect} from 'preact/hooks';

export default function extendAtIndex<T>(a: T[], b: Partial<T>[], onValue: (t: T[]) => any) {
  useEffect(() => {
    onValue(a.map((t, i) => ({...t, ...(b[i] || {})})))
  }, [a, b]);
}
